<mat-checkbox #innerCheckbox
    [labelPosition]="labelPosition"
    [required]="required"
    [name]="name"
    [indeterminate]="indeterminate"
    [id]="id"
    [disabled]="disabled"
    [disableRipple]="disableRipple"
    [color]="color"
    [value]="value"
    (change)="change.emit($event.checked)"
    [(ngModel)]="checked">
    <span  *ngIf="hasContent()">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </span>
</mat-checkbox>

<!-- Use this for determining if content exists -->
<!-- TODO: update this when the feature is created, https://github.com/angular/angular/issues/12530 -->
<div #contentRef
    style="display: none">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</div>
<ng-template #contentTemplate><ng-content></ng-content></ng-template>
